export default function({language}) {
    var config = {
        validators: ["mandatory", "onlyDigits", "onlyOneStartingZero"],
        thousands: " ",
        suffix: "kr",
        format: "integer",
        placeholder: "100 000 kr"
    };

    return {
        config,
        extendsType: "text-field"
    };
};
